import { useQuery } from "react-query";
import CarbonFootprintDetailsApi from "./Shipment.CarbonFootprintDetails.api";

export function useCarbonFootprintDetailsData(shipmentNumber: any) {
  return useQuery(["fetchShipmentCarbonFootprintDetailsData", shipmentNumber], CarbonFootprintDetailsApi.getCarbonFootprintDetails);
}